import clsx from 'clsx';

import styles from './Badge.module.scss';

import type { ReactNode } from 'react';

export type BadgeTone = 'success' | 'warning' | 'error' | 'info' | 'default';
export type BadgeSize = 'sm' | 'md' | 'lg' | 'xl';
export type BadgeShape = 'pill' | 'rectangle';

export type BadgeProps = {
  label: ReactNode;
  tone?: BadgeTone;
  size?: BadgeSize;
  shape?: BadgeShape;
  className?: string;
};

export function Badge({
  label,
  tone = 'default',
  size = 'md',
  shape = 'pill',
  className,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        styles.badge,
        styles[`tone-${tone}`],
        styles[`size-${size}`],
        shape === 'pill' ? styles.shapePill : styles.shapeRectangle,
        className,
      )}
    >
      {label}
    </span>
  );
}
